import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { H1, H2, H3 } from '../../Atoms';
export var StyledTitle = styled(H2)(_templateObject(), function (props) {
  return "\n        margin: 0;\n        text-transform: uppercase;\n        font-weight: ".concat(props.theme.components.textHeader.fontWeight, ";\n    ");
});
export var StyledSubTitle = styled(H3)(_templateObject2(), function (props) {
  return "\n        margin: 0;\n        font-weight: ".concat(props.theme.components.textHeader.fontWeight, ";\n        text-transform: uppercase;\n    ");
});
export var StyledTitleLarge = styled(H1)(_templateObject3(), function (props) {
  return "\n        margin: 0;\n        text-transform: uppercase;\n        font-weight: ".concat(props.theme.components.textHeader.fontWeight, ";\n    ");
});
export var StyledSubTitleLarge = styled(H2)(_templateObject4(), function (props) {
  return "\n        margin: 0;\n        font-weight: ".concat(props.theme.components.textHeader.fontWeight, ";\n        text-transform: uppercase;\n    ");
});
export var StyledLargeTextHeader = function StyledLargeTextHeader(props) {
  return "\n    ".concat(StyledSubTitleLarge, " {\n        &:nth-child(2) {\n            margin-top: ").concat(props.theme.components.textHeader.largeSubTitleMarginTop, ";\n        }\n    }\n");
};
export var StyledTextHeader = styled.div(_templateObject5(), function (props) {
  return "\n        position: relative;\n        display: flex;\n        flex-direction: column;\n\n        ".concat(props.large ? StyledLargeTextHeader(props) : '', "\n\n        ").concat(props.titleColor ? "\n            & > ".concat(props.large ? "".concat(StyledTitleLarge) : "".concat(StyledTitle), " {\n                color: ").concat(props.theme.components.textHeader[props.titleColor] || props.titleColor, ";\n            }\n        ") : '', "\n\n        ").concat(props.subTitleColor ? "\n            & > ".concat(props.large ? "".concat(StyledSubTitleLarge) : "".concat(StyledSubTitle), " {\n                color: ").concat(props.theme.components.textHeader[props.subTitleColor] || props.subTitleColor, ";\n            }\n        ") : '', "\n    ");
});